import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';

import { noop } from 'lib/utils';

const Star = ({
  'aria-label': ariaLabel,
  ariaLabelWhenRated,
  clickable = true,
  size = 'size1',
  stared = false,
  onClick = noop,
  onMouseEnter = noop,
}) => (
  <Icon
    aria-label={stared ? ariaLabelWhenRated : ariaLabel}
    as={clickable ? 'button' : 'svg'}
    className={
      stared
        ? 'text-communication-300 dark:text-communication-300'
        : 'text-neutral-high-400 dark:text-neutral-high-400'
    }
    name={stared ? 'rating-star-filled' : 'rating-star'}
    size={size}
    onClick={clickable ? onClick : noop}
    onMouseEnter={clickable ? onMouseEnter : noop}
  />
);

Star.propTypes = {
  ariaLabelWhenRated: PropTypes.string,
  clickable: PropTypes.bool,
  size: PropTypes.string.isRequired,
  stared: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

export default Star;
